import React from "react"
import styles from "./Shared.module.css"

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string
}

const Button: React.FC<ButtonProps> = ({ label, className, ...props }) => (
  <button {...props} className={`${styles.button} ${className || ""}`}>
    {label}
  </button>
)

export default Button
